import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FeathersService } from '../../feathers.service'
import { map, shareReplay } from 'rxjs/operators'
import { AllocationRole, User } from '../../../models/user'
import { OaCoordinator } from '../../../models/oaCoordinator'

@Injectable({
  providedIn: 'root',
})
export class OaCoordinatorService {
  private feathers = inject(FeathersService)

  stream$: Observable<User[]>

  constructor() {
    this.init()
  }

  public getAllCoordinatorsAsUsers(): Observable<User[]> {
    return this.stream$
  }

  private init() {
    // FIXME: This is a hack to get the coordinators as User instances for cases that rely on some behavior that is not (and won't be) implemented on OaCoordinator. Should be refactored away to use OaCoordinators but changing User to OaCoordinator has far-reaching consequences to other models such as Clients. Fix in ASPIK-565.
    this.stream$ = this.feathers.find(User, { $role: [AllocationRole.OaCoordinator], $join: { worker: true } }).pipe(
      map((aa) => aa.sort(User.sortByName)),
      shareReplay({ bufferSize: 1, refCount: true }),
    )
  }

  getAll(): Observable<OaCoordinator[]> {
    return this.feathers.find(OaCoordinator, {})
  }

  /**
   * Loads all OaCoordinators (assumed filtered to active allocation of currently logged-in user) with one additional OaCoordinator. To be used in a form where we need to show all coordinators along with the current coordinator of some user.
   * @param additionalOaCoordinatorId
   */
  async getOaCoordinatorsWithAddedOaCoordinatorById(additionalOaCoordinatorId: number): Promise<OaCoordinator[]> {
    if (!additionalOaCoordinatorId) {
      return await this.feathers.getOne(OaCoordinator, {})
    } else {
      return await this.feathers.getOne(OaCoordinator, { additionalCoordinatorIds: [additionalOaCoordinatorId] })
    }
  }
}
